import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDeleteOfferOptionMutation, useGetOfferOptionsQuery } from "../Service/offerOptionsApi";
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';
import { OfferOptionsRoutes } from '../../../Router/path';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import DataTable, { ColumnConfig } from "../../Shared/Components/DataTable";
import { OfferOption } from "../Types/offerOptionsTypes"; // Adjust the import path as necessary
import ActionButtons from "../../Shared/Components/ActionButtons";
import CustomCard from "../../Shared/Components/CustomCard/CustomCard";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

const OfferOptions = () => {
    const [page, setPage] = useState(0); // zero-based index
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedOfferOptionIds, setSelectedOfferOptionIds] = useState<
        number[]
    >([]);
    const navigate = useNavigate();

    const {
      data: offerOptions,
      isLoading: offerOptionsLoading,
      isError: isOfferOptionsError,
      error: offerOptionsError,
    } = useGetOfferOptionsQuery();

    const [deleteOffer] = useDeleteOfferOptionMutation();
    const handleCreate = useCreateRedirect(OfferOptionsRoutes.create);
    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedOfferOptionIds,
        (id) => deleteOffer(id).unwrap(),
        () => setSelectedOfferOptionIds([])
    );

    const columns: ColumnConfig<OfferOption>[] = [
        { key: "id", label: "ID" },
        { key: "name", label: "Nazwa" },
        {
            key: 'offerOptionsValues',
            label: 'Wartości opcji',
            render: (row) => (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {row.offerOptionsValues.map(v => <li key={v.id}>{v.value}</li>)}
                </ul>
            ),
        }
    ];


    return (
        <>
            <CustomCard
                icon={<InfoIcon fontSize="large" color="primary" />}
                title="Opcje ofert"
                subheader="Zarządzaj dostępnymi opcjami ofert w systemie"
                sx={{ mb: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        Na tej stronie możesz dodać, edytować i publikować opcje ofert.

                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Skorzystaj z przycisków poniżej, żeby dodać nową opcję, usunąć zaznaczone lub wybierz opcję z listy,
                        aby ją edytować.
                    </Typography>
                </Box>
                <ActionButtons
                    onCreate={handleCreate}
                    onDeleteSelected={handleDeleteSelected}
                />
            </CustomCard>
            <DataTable
                columns={columns}
                data={offerOptions || []}
                isLoading={offerOptionsLoading}
                isError={isOfferOptionsError}
                errorMessage={(offerOptionsError as any)?.data?.message}
                getRowId={(row) => row.id}
                onEdit={(id) => {
                    const item = offerOptions?.find(item => item.id === id);
                    if (item) {
                        navigate(OfferOptionsRoutes.update.replace(":offerOptionId", item.id.toString()));
                    }
                }}
                page={page}
                rowsPerPage={rowsPerPage}
                totalCount={offerOptions?.length || 0}
                onPageChange={(newPage) => setPage(newPage)}
                onRowsPerPageChange={(newSize) => {
                    setRowsPerPage(newSize);
                    setPage(0);
                }}
                selected={selectedOfferOptionIds}
                onSelectionChange={(selectedIds) => setSelectedOfferOptionIds(selectedIds)}
            />
        </>
    );
};

export default OfferOptions;
